import React from "react";
import pdfImage from "../assets/icon/free-pdf.png";
import Swal from "sweetalert2";
import axios from "../Config/axios";
import customAxios from "axios";
import { URLS } from "../Constants/constants";
import { replace, split } from "lodash";
import { returnDateTime } from "../functions/Functions";

const DownloadLinkBase64 = ({ filename, b64string, acntCode }) => {
  const current = returnDateTime();
  const fullFilename = `${current + "-" + acntCode}.pdf`;

  const checkEmail = async () => {
    let result = await axios
      .post("check/email", { acnt_code: acntCode })
      .then((res) => {
        let { code, data } = res?.data;
        if (code === 200) {
          let result = data;
          return result;
        } else {
          return false;
        }
      });
    return result;
  };

  const sentEmailData = async () => {
    await customAxios
      .post(
        URLS?.emailUrl,
        {
          acntCode: acntCode,
          isSendEmail: true,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic YXJpZzpwYXNzMTIzNDU2",
          },
        }
      )
      .then((res) => {
        let { status, message, data } = res.data;
        if (status === 200) {
          Swal.fire("Амжилттай илгээгдлээ", "", "success");
        } else {
          Swal.fire("Мэдэгдэл илгээхэд алдаа гарлаа", "", "warning");
        }
      });
  };

  const handleModal = () => {
    Swal.fire({
      title: "Мэдэгдэл",
      text: "Харилцагч та хадгаламжийн гэрээгээ хугацаанаасаа өмнө цуцалсан тохиолдолд таны урамшууллын эрхүүд хүчингүй болохыг анхаарна уу",
      showCloseButton: true,
      showDenyButton: true,
      confirmButtonText: "PDF ээр татах",
      denyButtonText: "Бүртгэлтэй мэйл хаяг руу илгээх",
      showLoaderOnConfirm: true,
      showLoaderOnDeny: true, 
      preDeny: async () => {
        let res = await checkEmail();
        if (res) {
          return Swal.fire({
            title: "Таны бүртгэл дээрхи холбоотой и-мэйл",
            text: res,
            showConfirmButton: true,
            showCancelButton: true,
            cancelButtonText: "Хаах",
            confirmButtonText: "Илгээх",
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              await sentEmailData();
            },
          }).then((result) => {
            if (result.isConfirmed) {
              Swal.fire("И-мэйл илгээгдлээ", "", "success");
            }
          });
        } else {
          return Swal.fire({
            title: "Та салбарт хандаж имэйл хаягаа бүртгүүлнэ үү",
            showCloseButton: true,
          });
        }
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        const pdfDownloadLink = document.getElementById("pdf-download-link");
        pdfDownloadLink.click();
        Swal.fire("Амжилттай татагдлаа", "", "success");
      }
    });
  };

  return (
    <React.Fragment>
      <button className="btn col-auto p-0" onClick={handleModal}>
        <img src={pdfImage} style={{ height: "1.5rem", width: "1.5rem" }} />
        <p
          style={{
            fontSize: "14px",
            color: "rgba(110,67,222,1)",
            fontWeight: 550,
          }}
        >
          Татах
        </p>
      </button>
      <a
        id="pdf-download-link"
        className="styled-like-a-button"
        download={fullFilename}
        href={`data:application/pdf;base64,${b64string}`}
      />
    </React.Fragment>
  );
};

export default DownloadLinkBase64;
